<template>
  <kds2-pop kind="date" role="dialog" :anchor="anchor" :label="tx('date.period')" @close="$emit('close')">
    <button type="button" class="k2-opt" :class="{ on: live }" data-fk="d-live" @click="$emit('live')">
      <k2-icon n="mdi-history" :s="20" /><span>{{ $t("last_24h") }}</span><k2-icon v-if="live" n="mdi-check" :s="20" />
    </button>
    <div class="k2-dpick">
      <button type="button" data-fk="d-prev" :aria-label="tx('date.prev')" @click="$emit('shift', -1)"><k2-icon n="mdi-chevron-left" :s="20" /></button>
      <input class="k2-date" type="date" data-fk="d-input" :value="date" :max="max" :aria-label="tx('date.period')" @change="onPick" />
      <button type="button" data-fk="d-next" :aria-label="tx('date.next')" :disabled="live || date >= max" @click="$emit('shift', 1)"><k2-icon n="mdi-chevron-right" :s="20" /></button>
    </div>
  </kds2-pop>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import Kds2Pop from "./Kds2Pop.vue";
import kds2Text from "@/mixins/kds2Text";

// Period: "Poslednja 24h" (uživo) ili jedan stariji dan (strelice ili izbor datuma).
export default {
  name: "Kds2DatePop",
  components: { K2Icon, Kds2Pop },
  mixins: [kds2Text],
  props: {
    anchor: { default: null },
    live: { type: Boolean, default: true },
    date: { type: String, default: "" }, // YYYY-MM-DD
    max: { type: String, default: "" }, // danas
  },
  methods: {
    onPick(e) {
      if (e.target.value) this.$emit("pick", e.target.value);
    },
  },
};
</script>
